import { Inject, Injectable } from "@nestjs/common";
import {  CommonResponseModel, ErrorResponse, GlobalResponseObject } from "@needle-management/shared-models";
import { PointTypeCreateDto, PointTypesToggleDto } from "./dtos";
import { PointTypeRepo } from "./repositories/point-type-repo";


@Injectable()
export class PointTypeService {
    constructor(
       
        private readonly pointTypeRepo: PointTypeRepo,
        // @Inject('TransactionaManager')
        // transactionManager: ITransactionManager,
        // @Inject('LoggerService')
        // logger: LoggerService,
        // private dataSource: DataSource
    ) {

    }
    
    async createPointTypes(dto: PointTypeCreateDto) {

        if (dto.pointType) {
            const findRecord = await this.pointTypeRepo.findOne({ where: { pointType: dto.pointType } });
            if (findRecord && findRecord.id !== dto.id) {
                return new GlobalResponseObject(false,23, "Point Type exists.");
            }
        }
        const pointType = this.pointTypeRepo.create(dto);
        await this.pointTypeRepo.save(pointType);
        // this.logMessage('Data Saved');
        return new GlobalResponseObject(true, dto?.id ? 922 : 923, dto.id ? 'Updated Successfully' : 'Created Successfully')
    }

    async getAllPointTypes(req:{}): Promise<CommonResponseModel> {
        // const getPointTypes = await this.pointTypeRepo.find({ select: ['id', 'pointType'], where: { companyCode: req.companyCode, unitCode: req.unitCode }, order: { createdAt: 'DESC' } });
          const getPointTypes = await this.pointTypeRepo.find({ select: ['id', 'pointType', 'isActive',], });
        if (!getPointTypes.length) {
            return new CommonResponseModel(false, 35416, "No Data Found")
        } else {
            return new CommonResponseModel(true, 35416, 'point type data retrieved successfully', getPointTypes)
        }
    }



    async togglePointTypes(req: PointTypesToggleDto): Promise<CommonResponseModel> {
        const status = await this.pointTypeRepo.findOne({ where: { id: req.id } });
        if (status) {
            await this.pointTypeRepo.update({ id: req.id }, { isActive: !status.isActive })
            let message = status.isActive ? "  Deactivated Successfully" : " Activated Successfully"
            return await new CommonResponseModel(true, 65152, message)
        } else {
            return await new CommonResponseModel(false, 6541, "No Data Found")
        }
    }

   

    async getActivePointType(): Promise<CommonResponseModel> {
        const data = await this.pointTypeRepo.find({ where: { isActive: true } });
        if (data.length > 0) {
            return new CommonResponseModel(true, 1, 'Data retrieved successfully', data);
        }
        return new CommonResponseModel(true, 1, 'No active Needle Size data found', []);
    }


}